import React from 'react';
import CardActions from '@material-ui/core/CardActions';
//import FlatButton from 'material-ui/FlatButton';
import { DeleteButton, ListButton, RefreshButton, ShowButton } from 'react-admin';

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const PostEditActions = ({ basePath, data, show=false, list=false, deleteButton=false, refresh=false   } ) => {
    show = show ? <ShowButton basePath={basePath} record={data} /> : ''
    list = list ? <ListButton basePath={basePath} /> : ''
    deleteButton = deleteButton ? <DeleteButton basePath={basePath} record={data} /> : ''
    refresh = refresh ? <RefreshButton /> : ''
    return <CardActions style={cardActionStyle}>
        {show}{list}{deleteButton}{refresh}
    </CardActions>
};

export default PostEditActions
